export default () => ({
  healthCareTeamList: [],
  profiles: {},
  caseRecords: {},
  healthEvents: {}
})
